import React from "react";
import { Link } from "react-router-dom";
import useReveal from "@/hooks/useReveal";
import StatusPill from "@/components/projects/StatusPill";
import FormatPill from "@/components/projects/FormatPill";
import { projectCardCopy, projectPath } from "@/content/projects";
import { track } from "@/lib/analytics";

export default function ProjectCard({
  project,
  index = 0,
  muted = false,
  linkToDetail = true,
}) {
  const r = useReveal();
  const copy = projectCardCopy(project);
  const href = projectPath(project.slug);
  const id = project.slug || project.id;

  return (
    <article
      ref={r.ref}
      className={`panel flex flex-col relative overflow-hidden ${r.className}`}
      data-testid={`project-card-${id}`}
      style={{
        transitionDelay: `${index * 90}ms`,
        minHeight: 260,
        opacity: muted ? 0.9 : 1,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          background:
            "repeating-linear-gradient(90deg, rgba(214,175,99,0.06) 0px, rgba(214,175,99,0.06) 2px, transparent 2px, transparent 14px), radial-gradient(120% 60% at 50% 0%, rgba(214,175,99,0.08), transparent 55%)",
          pointerEvents: "none",
          opacity: muted ? 0.35 : 0.65,
        }}
      />
      <div className="relative flex flex-col flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <StatusPill status={project.status} />
          <FormatPill format={project.format} projectId={id} />
        </div>
        <h3
          className="font-display mt-5"
          style={{
            color: "var(--sokno-cream)",
            fontSize: 26,
            fontWeight: 500,
            lineHeight: 1.15,
            letterSpacing: "-0.005em",
          }}
        >
          {linkToDetail ? (
            <Link
              to={href}
              data-testid={`project-card-link-${id}`}
              onClick={() =>
                track("cta_click", {
                  route: href,
                  project_slug: project.slug,
                  cta_label: "View project",
                  source_category: "project_card",
                })
              }
              style={{ color: "inherit", textDecoration: "none" }}
            >
              {project.title}
            </Link>
          ) : (
            project.title
          )}
        </h3>
        <p
          className="mt-3 flex-1"
          style={{ color: "var(--sokno-cream-dim)", fontSize: 14.5, lineHeight: 1.7 }}
        >
          {copy}
        </p>
        {linkToDetail && (
          <Link
            to={href}
            className="link-gold mt-5"
            style={{ fontSize: 13, letterSpacing: "0.08em", alignSelf: "flex-start" }}
            aria-label={`View project ${project.title}`}
            onClick={() =>
              track("cta_click", {
                route: href,
                project_slug: project.slug,
                cta_label: "View project",
                source_category: "project_card",
              })
            }
          >
            View project <span aria-hidden>→</span>
          </Link>
        )}
      </div>
    </article>
  );
}
